/**
 * TiempoAtencionTimer — Timer mm:ss desde hora_inicio de la atención.
 *
 * Requirements: M4.15
 */

import { useState, useEffect } from "react";
import { Clock } from "lucide-react";

interface TiempoAtencionTimerProps {
  horaInicio: string;
}

function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

export function TiempoAtencionTimer({ horaInicio }: TiempoAtencionTimerProps) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const inicio = new Date(horaInicio).getTime();

    const calcular = () => {
      const ahora = Date.now();
      setElapsed(Math.floor((ahora - inicio) / 1000));
    };

    calcular();
    const interval = setInterval(calcular, 1000);
    return () => clearInterval(interval);
  }, [horaInicio]);

  return (
    <div className="flex items-center gap-1 text-sm text-muted-foreground">
      <Clock className="h-3.5 w-3.5" />
      <span className="font-mono">{formatDuration(elapsed)}</span>
    </div>
  );
}
